import { THeadingProps } from '../types/heading.types';
import { StringField } from '../../../../types/types';
import { TLinkField } from '../../../../types/sitecore.types';
import { TextComponentDeciderProps } from '../../TextComponentDecider/textComponentDecider.types';

export class HeadingModel {
  private readonly props?: THeadingProps;

  constructor(props: THeadingProps) {
    this.props = props || null;
  }

  get title(): StringField {
    if (typeof this.props?.title === 'string') return { value: this.props?.title } as StringField;
    return this.props?.title as StringField;
  }

  get eyebrow(): StringField {
    if (typeof this.props?.eyebrow === 'string') return { value: this.props?.eyebrow } as StringField;
    return this.props?.eyebrow as StringField;
  }

  get subtitle(): StringField {
    if (typeof this.props?.subtitle === 'string') return { value: this.props?.subtitle } as StringField;
    return this.props?.subtitle as StringField;
  }

  get link(): TLinkField | undefined {
    return this.props?.link;
  }
  get isLinkExists(): boolean {
    return !!this.props?.link?.value?.href;
  }
  get editable(): boolean {
    return !!this.props?.editable;
  }

  titleTextType(customTextTitle: boolean, richTextTitle: boolean): TextComponentDeciderProps['type'] {
    if (customTextTitle) {
      return 'CustomText';
    }
    if (richTextTitle) {
      return 'RichText';
    }
    return 'Text';
  }

  subtitleTextType(customTextSubtitle: boolean): TextComponentDeciderProps['type'] {
    return customTextSubtitle ? 'CustomText' : 'RichText';
  }
}
